import React from 'react';
import './App.scss';
import { Header } from './components/Header';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";


//Declare New Components Here
import Home from './components/Home';
import PersonalDetails from "./components/PersonalDetails.jsx";
import FundTransfer from "./components/FundTransfer";
import ReviewDetails from "./components/ReviewDetails";
import errorscreen from "./components/error";

function App() {
  return (
    <Router>
      <div className="content">
        <Header projectName={'mbank_fundtransfer'} />
        <Route exact path="/" ><Redirect to="/dcofmcca/PersonalDetails" /></Route>
        {/* <Route exact path="/dcofmcca" component={Home} /> */}
        <Route exact path="/dcofmcca" ><Redirect to="/dcofmcca/PersonalDetails" /></Route>
        <Route exact path="/dcofmcca/dcofmcca" ><Redirect to="/dcofmcca/PersonalDetails" /></Route>
        <Route path="/dcofmcca/PersonalDetails" component={PersonalDetails} />
        <Route path="/dcofmcca/Details" component={FundTransfer} />
        <Route path="/dcofmcca/ReviewDetails" component={ReviewDetails} />
        <Route path="/dcofmcca/error" component={errorscreen} />
      </div>
      <br></br><br></br>
    </Router>
  );
}


export default App;
